import React, { Component, createRef } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import Headers from '../Header';
import NavigationBar from '../Navigation';
import Loader from '../../common/Loader';
import Pagination from '../../common/Pagination';
import SessionType from '../../common/SessionType';
import NoAppointmentsFound from '../../common/NoDataFound';
import SessionStatusButton from '../../common/SessionStatusButton';
import SessionCancellation from '../../common/SessionCancellation';
import {
    getEducatorForReferral,
    getTutorSessionList,
    submitReferralNotes,
    getAllSessions,
} from '../../../action/educator/AppointmentAction';
import store from '../../../../sessionStorage';
import { RESPONSE_CONSTANT } from '../../../../utils/ResponseConstant';
import { showNotification } from '../../../action/NotificationAction';
import { userTypePhysician, paginationCount } from '../../../../utils/URL';
import { PATH } from '../../../../utils/Constants';
import { getNumberOfStudentsList } from './../../../action/educator/AppointmentAction';
import { getVisitInformation, sessionAppointmentCancel } from '../../../action/Admin/CommonAction';
import FlaggingCategorySession from '../../common/FlaggingCategorySession';
import {
    submitFlagSession,
    flagSessionCategory,
} from '../../../action/educator/FlagSessionModuleAction';
import {
    BroadCastSession,
    ClassroomSession,
    ConferenceCall,
    Good,
    InPerson,
    OnDemand,
    Scheduled,
    Tutor,
    Unknown,
} from '../../../../utils/common/NamingTerms';
import SessionReferral from '../../tutor/session/SessionReferralModal';
import CheckMediaAccess from '../../common/CheckMediaAccess';
import CheckNetworkConnection from '../../common/CheckNetworkConnection';
import { getCallStatus } from '../../../action/VideoCallAction';
import { myLog } from '../../../../utils/Utility';
import LanguageContext, { LanguageProvider } from '../../../../utils/common/LanguageContext';
import AppConfig from '../../../../utils/common/DomainConfiguration';
import {
    pruneWhiteboardSessionsExcept,
    setActiveWhiteboardSession,
} from '../../../../utils/WhiteboardSessionStorage';

// Register Spanish locale for DatePicker
registerLocale('es', es);

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t, language }) => (
                        <WrappedComponent {...this.props} t={t} language={language} />
                    )}
                </LanguageContext.Consumer>
            );
        }
    };
};

/**
 * @package VirtOwl
 * @type {React.ComponentClass}
 */
let today = new Date();
let strDate = moment(today).format('YYYY-MM-DD HH:mm:ss');
const MEETING_SUMMARY_PENDING_TIMEOUT_MS = 5 * 60 * 1000;
const { detect } = require('detect-browser');
const browser = detect();
class SessionList extends Component {
    static propTypes = {
        sessionList: PropTypes.object,
        getTutorSessionList: PropTypes.func,
        match: PropTypes.any,
        sessionAppointmentCancel: PropTypes.func,
        getNumberOfStudentsList: PropTypes.func,
        getEducatorForReferral: PropTypes.func,
        getAllSessions: PropTypes.func,
    };
    constructor(props) {
        super(props);
        this.state = {
            mobileNav: false,
            isLoading: false,
            strDate,
            type: 'all',
            time: '',
            currentPage: 0,
            todosPerPage: paginationCount,
            totalPages: 0,
            offSetValue: 0,
            date: new Date(),
            customSelect: false,
            userId: '',
            cancelAppoimentIsOpen: false,
            sessionReferralModal: false,
            noSession: false,
            cancelationReason: '',
            isModalOpen: false,
            sessionList: [],
            educatorList: [],
            sessionId: 0,
            btnLoading: false,
            isFlagModalOpen: false,
            flagSessionId: '',
            isFlagSession: false,
            flagReason: '',
            flagCategoryId: '',
            otherCategory: '',
            flagCategoryList: [],
            isFlagCategoryLoading: false,
            isEducatorLoading: false,
            flagBtnLoading: false,
            referralNotes: '',
            checkPermissionStatus: false,
            visitType: '',
            pendingSessionId: '',
            isMeetingSummaryPending: false,
        };
        this.mediaChecker = new CheckMediaAccess();
        this.networkChecker = new CheckNetworkConnection();
        this.networkChecker.browser = browser.name;
        this.chatContainerRef = createRef();
        this.pendingSummaryTimeout = null;
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleChangeFilterSortBy = this.handleChangeFilterSortBy.bind(this);
        this.handleChangeFilterCustomDate = this.handleChangeFilterCustomDate.bind(this);
    }

    /**
     * @inheritDoc
     */
    componentWillMount() {
        this.getFlagCategoryList();
        this.invokeAppointmentList(
            this.state.type,
            '',
            this.state.currentPage,
            this.state.todosPerPage
        );
    }

    /**
     * @inheritDoc
     */
    componentDidMount() {
        const pendingSessionId = window.sessionStorage.getItem('LAST_VISITED_SESSION_ID') || '';
        const isMeetingSummaryPending =
            window.sessionStorage.getItem('MEETING_SUMMARY_PENDING') === 'true';
        const pendingAtRaw = window.sessionStorage.getItem('MEETING_SUMMARY_PENDING_AT');
        const pendingAt = pendingAtRaw ? Number(pendingAtRaw) : Date.now();

        this.setState({
            pendingSessionId,
            isMeetingSummaryPending,
        });

        if (isMeetingSummaryPending && pendingSessionId) {
            if (!pendingAtRaw) {
                window.sessionStorage.setItem('MEETING_SUMMARY_PENDING_AT', String(pendingAt));
            }
            this.schedulePendingSummaryTimeout(pendingAt);
        }

        window.addEventListener('meeting-summary-received', this.handleMeetingSummarySocket);

        this.interval = setInterval(() => {
            this.ensurePendingSummaryNotExpired();
            this.setState({ time: Date.now() });
            this.invokeAppointmentList(
                this.state.type,
                this.state.type === 'custom' ? this.state.strDate : '',
                this.state.currentPage,
                this.state.todosPerPage
            );
        }, 60000);
    }

    /**
     * @inheritDoc
     */
    componentWillUnmount() {
        clearInterval(this.interval);
        this.clearPendingSummaryTimeout();
        window.removeEventListener('meeting-summary-received', this.handleMeetingSummarySocket);
    }

    clearPendingSummaryTimeout = () => {
        if (this.pendingSummaryTimeout) {
            clearTimeout(this.pendingSummaryTimeout);
            this.pendingSummaryTimeout = null;
        }
    };

    schedulePendingSummaryTimeout = (pendingAt) => {
        this.clearPendingSummaryTimeout();

        const elapsed = Date.now() - Number(pendingAt || Date.now());
        const remaining = MEETING_SUMMARY_PENDING_TIMEOUT_MS - elapsed;

        if (remaining <= 0) {
            this.clearMeetingSummaryPendingState();
            return;
        }

        this.pendingSummaryTimeout = setTimeout(() => {
            this.clearMeetingSummaryPendingState();
        }, remaining);
    };

    clearMeetingSummaryPendingState = () => {
        window.sessionStorage.removeItem('LAST_VISITED_SESSION_ID');
        window.sessionStorage.removeItem('MEETING_SUMMARY_PENDING');
        window.sessionStorage.removeItem('MEETING_SUMMARY_PENDING_AT');
        this.clearPendingSummaryTimeout();
        this.setState(
            {
                pendingSessionId: '',
                isMeetingSummaryPending: false,
            },
            () => {
                this.invokeAppointmentList(
                    this.state.type,
                    this.state.type === 'custom' ? this.state.strDate : '',
                    this.state.currentPage,
                    this.state.todosPerPage
                );
            }
        );
    };

    ensurePendingSummaryNotExpired = () => {
        if (!this.state.isMeetingSummaryPending) {
            return;
        }

        const pendingAtRaw = window.sessionStorage.getItem('MEETING_SUMMARY_PENDING_AT');
        const pendingAt = Number(pendingAtRaw);
        if (!Number.isFinite(pendingAt)) {
            this.clearMeetingSummaryPendingState();
            return;
        }

        if (Date.now() - pendingAt >= MEETING_SUMMARY_PENDING_TIMEOUT_MS) {
            this.clearMeetingSummaryPendingState();
        }
    };

    handleMeetingSummarySocket = (event) => {
        const summarySessionId = event?.detail?.sessionId;
        const { pendingSessionId, isMeetingSummaryPending } = this.state;

        if (!isMeetingSummaryPending) {
            return;
        }

        if (!summarySessionId || String(summarySessionId) === String(pendingSessionId)) {
            this.clearMeetingSummaryPendingState();
        }
    };

    /**
     * Invoke Appointment List
     * @param {Number} type
     * @param {Date} strDate
     * @param {Number} pagenumber
     * @param {Number} pagePerCount
     */
    invokeAppointmentList(type, strDate, pagenumber, pagePerCount) {
        this.setState({ cancelationReason: '' });
        this.setState({ btnLoading: false });
        this.isLoading();
        this.props.getTutorSessionList(
            type,
            strDate,
            (pagenumber = pagenumber + 1),
            pagePerCount,
            (response) => {
                this.isLoading();
                if (response) {
                    if (response.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                        this.setState({
                            totalPages: 0,
                            noSession: true,
                            sessionList: [],
                        });
                    } else {
                        this.setState({
                            currentPage: response.response.pageNumber,
                            noSession: false,
                            totalPages: response.response.totalPages,
                            sessionList: response.response.data,
                        });
                    }
                }
            }
        );
    }

    invokeVisitInfo(visitId, initialCall, callback) {
        this.isLoading();
        this.props.getVisitInformation(visitId, (response) => {
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                let optionDetails = [];
                if (response.response.sessionUsers && response.response.sessionUsers.length) {
                    response.response.sessionUsers.forEach((element) => {
                        let obj = {
                            label: element.name,
                            value: element.id,
                        };
                        optionDetails.push(obj);
                    });
                }
                this.setState(
                    {
                        visitInfo: response.response,
                        sessionStatus: response.response.sessionStatus,
                        isTabName:
                            response.response.sessionStatus === 'Note Pending' ? 'chat' : 'notes',
                        patientEmail: response.response.tutor?.email,
                        patientName: response.response.tutor?.name,
                        sessionStudents: response.response.sessionUsers,
                        uploadedImages: response.response.soapNote?.visitComplaintImages,
                        visitType: response.response.visitType,
                        materialUploadedImages: response.response.soapNote?.materialImages,
                        broadcast: response.response.activeSession?.broadcast,
                        patientUserId: response.response.tutee?.userId || 0,
                    },
                    () => {
                        if (
                            this.state.broadcast &&
                            this.state.broadcast?.hls &&
                            response.response.visitType === BroadCastSession
                        ) {
                            store.set('broadcastUrl', this.state.broadcast?.hls);
                        } else {
                            store.set('broadcastUrl', '');
                        }
                        if (
                            this.state.sessionStatus === 'Missed' ||
                            this.state.sessionStatus === 'Cancelled' ||
                            this.state.sessionStatus === 'Note Pending' ||
                            this.state.sessionStatus === 'Completed'
                        ) {
                            clearInterval(this.timer);
                        }
                        if (response.response.sessionStatus === 'Note Pending') {
                            this.setState({ chatLoading: true });
                            this.getSessionSummaryChatWithPagination(
                                this.state.visitInfo.id,
                                0,
                                this.state.chatPerPage
                            );
                        }
                        if (
                            response.response.visitType !== ClassroomSession &&
                            response.response.visitType !== BroadCastSession && response.response.visitType !== ConferenceCall
                        ) {
                            if (initialCall || this.state.visitType === OnDemand) {
                                if (response.response && response.response.isOnDemand) {
                                    if (response.response && response.response.visitStatus === 1) {
                                        if (
                                            response.response &&
                                            response.response.userCategory === 1 &&
                                            response.response.physicianAppointmentType === 0
                                        ) {
                                            this.setState({
                                                sessionStatus: 'Enter Virtual Class Room',
                                            });
                                        } else {
                                            this.setState({
                                                sessionStatus: Scheduled,
                                            });
                                        }
                                    }
                                    this.setState({ countDown: '0:00:00' });
                                }
                                if (this.state.visitInfo && this.state.visitInfo.isAppointment) {
                                    this.interval = setInterval(() => {
                                        this.setState({ time: Date.now() });
                                        let d1 = moment(
                                            this.state.visitInfo.appointment?.startTime
                                        );
                                        let d2 = moment(this.state.time);
                                        let ms = moment(d1, 'YYYYMMDD HH:mm:ss').diff(
                                            moment(d2, 'YYYYMMDD HH:mm:ss')
                                        );
                                        let d = moment.duration(ms);
                                        let ans =
                                            Math.floor(d.asHours()) +
                                            moment.utc(ms).format(':mm:ss');

                                        let end = moment(this.state.visitInfo.appointment?.endTime);

                                        if (
                                            moment(d2, 'YYYYMMDD HH:mm:ss').isSameOrAfter(
                                                moment(d1, 'YYYYMMDD HH:mm:ss').subtract(
                                                    10,
                                                    'minute'
                                                )
                                            ) &&
                                            moment(d2, 'YYYYDDMM HH:mm:ss').isBefore(
                                                d1,
                                                'YYYYMMDD HH:mm:ss'
                                            )
                                        ) {
                                            if (this.state.visitInfo.visitStatus === 1) {
                                                if (
                                                    response.response &&
                                                    response.response.userCategory === 1 &&
                                                    response.response.physicianAppointmentType === 0
                                                ) {
                                                    this.setState({
                                                        sessionStatus: 'Enter Virtual Class Room',
                                                    });
                                                } else {
                                                    this.setState({
                                                        sessionStatus: Scheduled,
                                                    });
                                                }
                                            }
                                            this.setState({ countDown: ans });
                                        } else if (
                                            moment(d2, 'YYYYMMDD HH:mm:ss').isBefore(
                                                moment(d1, 'YYYYMMDD HH:mm:ss')
                                            )
                                        ) {
                                            this.setState({ countDown: ans });
                                        } else if (
                                            moment(d2, 'YYYYMMDD HH:mm:ss').isSameOrAfter(
                                                d1,
                                                'YYYYMMDD HH:mm:ss'
                                            ) &&
                                            moment(d2, 'YYYYMMDD HH:mm:ss').isBefore(
                                                end,
                                                'YYYYMMDD HH:mm:ss'
                                            )
                                        ) {
                                            if (this.state.visitInfo.visitStatus === 1) {
                                                if (
                                                    response.response &&
                                                    response.response.userCategory === 1 &&
                                                    response.response.physicianAppointmentType === 0
                                                ) {
                                                    this.setState({
                                                        sessionStatus: 'Enter Virtual Class Room',
                                                    });
                                                } else {
                                                    this.setState({
                                                        sessionStatus: Scheduled,
                                                    });
                                                }
                                            }
                                            clearInterval(this.interval);
                                            this.setState({ countDown: '0:00:00' });
                                        } else {
                                            this.setState({ countDown: '0:00:00' });
                                        }
                                    }, 1000);
                                }
                            }
                        }
                        if (callback) {
                            callback(this.state.patientUserId);
                        }
                    }
                );
                this.isLoading();
            } else if (response.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                myLog('error');
            }
        });
    }

    getAllSessions(type, strDate, pagenumber, itemsPerPage) {
        this.isLoading();
        this.props.getAllSessions(
            type,
            strDate,
            (pagenumber = pagenumber + 1),
            itemsPerPage,
            (response) => {
                this.isLoading();
                if (response) {
                    if (response.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                        this.setState({
                            totalPages: 0,
                            noSession: true,
                            sessionList: [],
                        });
                    } else {
                        this.setState({
                            currentPage: response.response.pageNumber,
                            noSession: false,
                            totalPages: response.response.totalPages,
                            sessionList: response.response.data,
                        });
                    }
                }
            }
        );
    }

    //getEducatorForReferral
    getEducatorForReferral(sessionStartTime, sessionEndTime, visitId) {
        this.setState({ isEducatorLoading: true });
        const values = {
            search: '',
            pageNumber: 1,
            itemsPerPage: 99999,
        };
        this.props.getEducatorForReferral(
            sessionStartTime,
            sessionEndTime,
            visitId,
            values,
            (result) => {
                this.setState({ isEducatorLoading: false });
                if (result) {
                    this.setState({
                        educatorList: result.response.data,
                    });
                } else {
                    this.props.showNotification(result.message, RESPONSE_CONSTANT.WARNING);
                }
            }
        );
    }

    // getFlagCategoryList
    getFlagCategoryList() {
        this.setState({ isFlagCategoryLoading: true });
        this.props.flagSessionCategory((response) => {
            this.setState({ isFlagCategoryLoading: false });
            if (response) {
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    this.setState({ flagCategoryList: response.response });
                } else {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.WARNING);
                    this.setState({ flagCategoryList: [] });
                }
            }
        });
    }

    // handleChangeFilterSortBy
    handleChangeFilterSortBy = (e) => {
        let type = e.target.value;
        if (type === 'custom') {
            this.setState({ customSelect: true, date: null });
        } else {
            this.setState({ customSelect: false, type }, () => {
                this.invokeAppointmentList(
                    type,
                    '',
                    this.state.currentPage,
                    this.state.todosPerPage
                );
            });
        }
    };

    // Handle  Filter  custom
    handleChangeFilterCustomDate = (day) => {
        let strDate = moment(day).format('YYYY-MM-DD');
        this.setState(
            {
                type: 'custom',
                strDate,
                date: day,
            },
            () => {
                this.invokeAppointmentList(
                    this.state.type,
                    this.state.strDate,
                    this.state.currentPage,
                    this.state.todosPerPage
                );
            }
        );
    };

    // Handle  Page change
    handlePageChange(event) {
        const newPage = Number(event.selected);
        this.setState(
            {
                currentPage: newPage,
                offSetValue: newPage * this.state.todosPerPage,
            },
            () => {
                this.invokeAppointmentList(
                    this.state.type,
                    this.state.strDate,
                    this.state.currentPage,
                    this.state.todosPerPage
                );
            }
        );
    }

    //onClickMobileNav
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    // Handle toggle loader
    isLoading() {
        this.setState({ isLoading: !this.state.isLoading });
    }

    //Open Session Referral Modal
    openSesssionReferralModal = (visitId) => {
        this.setState({ sessionReferralModal: true, visitId: visitId });
    };

    // Open Cancel Modal
    openCancelModal = (visitId) => {
        this.setState({ cancelAppoimentIsOpen: true, visitId: visitId });
    };

    //openFlagModal
    openFlagModal = (flagId) => {
        this.setState(() => ({
            isFlagModalOpen: true,
            flagSessionId: flagId,
        }));
    };

    //submitReferral
    submitReferral = (educatorId) => {
        const { visitId, referralNotes } = this.state;
        if (!educatorId) {
            this.props.showNotification(
                RESPONSE_CONSTANT.EDUCATOR_MANDATORY,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        const values = {
            educatorId: educatorId,
            sessionId: visitId,
            notes: referralNotes,
        };
        this.setState({ btnLoading: true });
        this.props.submitReferralNotes(values, (response) => {
            this.setState({ btnLoading: false });
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState(
                    {
                        sessionReferralModal: false,
                        isModalOpen: false,
                    },
                    () => {
                        this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
                        this.invokeAppointmentList(
                            this.state.type,
                            '',
                            this.state.currentPage,
                            this.state.todosPerPage
                        );
                    }
                );
            } else {
                if (response.message) {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.WARNING);
                    this.setState({
                        sessionReferralModal: false,
                        isModalOpen: false,
                    });
                }
            }
        });
    };

    // submitCancelation
    submitCancelation = () => {
        const { visitId, cancelationReason } = this.state;
        const values = {
            id: visitId,
            reason: cancelationReason,
        };
        if (!values.reason) {
            this.props.showNotification(
                RESPONSE_CONSTANT.CANCELATION_REASON_EMPTY,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        this.setState({ btnLoading: true });
        this.props.sessionAppointmentCancel(values, (response) => {
            this.setState({ btnLoading: false });
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState(
                    {
                        cancelAppoimentIsOpen: false,
                        isModalOpen: false,
                    },
                    () => {
                        this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
                        this.invokeAppointmentList(
                            this.state.type,
                            '',
                            this.state.currentPage,
                            this.state.todosPerPage
                        );
                        return;
                    }
                );
            } else {
                if (response.message) {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.WARNING);
                    this.setState({
                        cancelAppoimentIsOpen: false,
                        isModalOpen: false,
                    });
                }
                return;
            }
        });
    };

    preCallTest = async (type, visitId) => {
        try {
            this.setState({ checkPermissionStatus: true });
            await this.mediaChecker.finalCheckingPermission();

            const {
                cameraGranted,
                microphoneGranted,
                systemCameraBlocked,
                systemMicrophoneBlocked,
            } = this.mediaChecker.state;

            if (
                cameraGranted &&
                microphoneGranted &&
                !systemCameraBlocked &&
                !systemMicrophoneBlocked
            ) {
                const networkGood =
                    this.networkChecker.browser === 'firefox' ||
                    this.networkChecker.browser === 'safari'
                        ? await this.networkChecker.checkfirefoxNetworkSignal()
                        : await this.networkChecker.checkNetworkSignal();

                const { networkQuality } = this.networkChecker.state;
                if (networkGood && (networkQuality === Good || networkQuality === Unknown)) {
                    this.handleVideoCall(type, visitId);
                }
            } else {
                this.setState({ checkPermissionStatus: false });
            }
        } catch (error) {
            console.log('error: ', error);
        }
    };

    navigateToDetailScreen = (type, visitId) => {
        setActiveWhiteboardSession(visitId);
        pruneWhiteboardSessionsExcept(visitId);
        if (type === 'waitingRoom') {
            this.props.history.push(
                `${PATH.IM_PHYSICIAN.WAITINGROOM}/${this.props.match.params.userId}/${visitId}`
            );
        } else {
            this.preCallTest(type, visitId);
        }
    };

    canShowEditButton = (session = {}) => {
        const hasStartedSession =
            session.hasStartedSession === true ||
            String(session.hasStartedSession || '')
                .trim()
                .toLowerCase() === 'true';

        if (session.sessionStatus === 'Booked' || session.sessionStatus === Scheduled) {
            return false;
        }

        if (/Missed$/i.test(session.sessionStatus || '')) {
            return false;
        }

        const isOneToOneSession =
            session.sessionType !== ClassroomSession &&
            session.sessionType !== BroadCastSession &&
            session.sessionType !== ConferenceCall;

        if (isOneToOneSession && hasStartedSession) {
            return false;
        }

        return session.isAllowEdit || session.isAllowToEdit;
    };

    buildRescheduleSessionState = (visitInfo = {}) => {
        const startDateTime =
            visitInfo?.onDemand?.startTime ||
            visitInfo?.appointment?.startTime ||
            visitInfo?.sessionStartDate ||
            '';
        const endDateTime =
            visitInfo?.onDemand?.endTime ||
            visitInfo?.appointment?.endTime ||
            visitInfo?.sessionEndDate ||
            '';

        const startMoment = startDateTime ? moment(startDateTime) : null;
        const endMoment = endDateTime ? moment(endDateTime) : null;
        const sessionDate =
            startMoment && startMoment.isValid()
                ? startMoment.format('YYYY-MM-DD')
                : moment().format('YYYY-MM-DD');

        return {
            visitId: visitInfo.id,
            visitType: visitInfo.visitType || null,
            sessionType: visitInfo.sessionType || '',
            sessionDate,
            sessionStartTime:
                startMoment && startMoment.isValid()
                    ? startMoment.format('YYYY-MM-DD HH:mm:ss')
                    : startDateTime,
            sessionEndTime:
                endMoment && endMoment.isValid()
                    ? endMoment.format('YYYY-MM-DD HH:mm:ss')
                    : endDateTime,
            subjectId: visitInfo.expertiseCategoryId || null,
            subjectLabel: visitInfo.expertiseCategory || '',
            subCategoryId: visitInfo.expertiseId || null,
            subCategoryLabel: visitInfo.expertise || '',
            studentId: visitInfo.tutee?.id || visitInfo.studentId || null,
            studentName: visitInfo.tutee?.name || visitInfo.studentName || '',
            sessionUsers: Array.isArray(visitInfo.sessionUsers) ? visitInfo.sessionUsers : [],
            externalUserEmails: Array.isArray(visitInfo.sessionUsers)
                ? visitInfo.sessionUsers
                      .filter((user) => user?.thirdParty === true && user?.email)
                      .map((user) => String(user.email).toLowerCase())
                : [],
            topic: visitInfo.topic || visitInfo.summary || '',
            comments: visitInfo.comments || '',
            referenceFiles: Array.isArray(visitInfo.referenceFiles) ? visitInfo.referenceFiles : [],
            hasStartedSession: visitInfo.hasStartedSession,
        };
    };

    navigateToSessionEdit = (visitId) => {
        if (!visitId || !this.props.match?.params?.userId) {
            return;
        }

        this.props.getVisitInformation(visitId, (response) => {
            if (response?.code !== RESPONSE_CONSTANT.SUCCESS_CODE || !response?.response?.id) {
                this.props.showNotification(
                    response?.message || RESPONSE_CONSTANT.SOMETHING_WENT_WRONG,
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }

            this.props.history.push({
                pathname: `${PATH.IM_PHYSICIAN.APPOINTMENT}/${this.props.match.params.userId}/update`,
                state: {
                    isReschedule: true,
                    rescheduleSession: this.buildRescheduleSessionState(response.response),
                },
            });
        });
    };

    handleVideoCall(type, visitId) {
        sessionStorage.setItem('VISIT_TYPE', type);
        this.props.getCallStatus(visitId, (response) => {});
        const userId = store.get('userSession').id;
        const sessionId = this.state.summary ? this.state.sessionId : visitId;
        setActiveWhiteboardSession(sessionId);
        pruneWhiteboardSessionsExcept(sessionId);
        sessionStorage.setItem('hasJoinedSession', 'true');
        if (type === 'class_room' || type === 'conference_call') {
            this.props.history.push(
                `${PATH.IM_PHYSICIAN.VIDEO_CALL}/${sessionId}/${Tutor}/${userId}/classroom`
            );
        } else if (type === 'broadcast') {
            this.props.history.push(
                `${PATH.IM_PHYSICIAN.VIDEO_CALL}/${sessionId}/${Tutor}/${userId}/broadcast`
            );
        } else {            
            this.invokeVisitInfo(visitId, false, () => {
                const videoCallPath =
                    this.state.visitInfo.sessionType === InPerson
                        ? `${PATH.IM_PHYSICIAN.VIDEO_CALL}/${sessionId}/${Tutor}/${userId}`
                        : `${PATH.IM_PHYSICIAN.VIDEO_CALL}/${sessionId}/${Tutor}/${userId}/${this.state.patientUserId}`;

                this.props.history.push(videoCallPath);
            });
        }
    }

    // submit fn() for flag
    flagSubmitBtn = () => {
        const { flagReason, flagCategoryId, flagSessionId, otherCategory } = this.state;
        const values = {
            sessionId: flagSessionId,
            categoryId: flagCategoryId?.id,
            otherCategoryReason: otherCategory,
            reason: flagReason,
            status: '',
        };
        if (!values.categoryId) {
            this.props.showNotification(
                RESPONSE_CONSTANT.CATEGORY_MANDATORY,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        if (flagCategoryId.values === 'Other' && !values.otherCategoryReason) {
            this.props.showNotification(RESPONSE_CONSTANT.FLAG_STATUS, RESPONSE_CONSTANT.WARNING);
            return;
        }
        if (!values.reason) {
            this.props.showNotification(
                RESPONSE_CONSTANT.CANCELATION_REASON_EMPTY,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }
        this.setState({ flagBtnLoading: true });
        this.props.submitFlagSession(values, (response) => {
            this.setState({
                flagBtnLoading: false,
                isFlagModalOpen: false,
                otherCategory: '',
                flagCategoryId: '',
                flagReason: '',
            });
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
                this.invokeAppointmentList(
                    this.state.type,
                    '',
                    this.state.currentPage,
                    this.state.todosPerPage
                );
                return;
            } else {
                if (response.message) {
                    this.props.showNotification(response.message, RESPONSE_CONSTANT.ERROR);
                }
                return;
            }
        });
    };

    // onChangeFlagSession
    onChangeFlagSession = (event, name) => {
        this.setState({
            [name]: name === 'flagCategoryId' ? event : event.target.value,
        });
    };

    // renders Row Data
    renderSessionList() {
        return (
            <>
                {this.state.noSession || !this.state.sessionList.length ? (
                    <NoAppointmentsFound isFrom={'Session'} />
                ) : (
                    <>
                        {this.state.sessionList.map((session, index) => {
                            const isPendingSummary =
                                this.state.isMeetingSummaryPending &&
                                String(this.state.pendingSessionId) === String(session.sessionId);

                            return (
                            <div
                                className={`h-auto p-4 rounded-lg bg-card relative ${
                                    isPendingSummary ? 'opacity-60 pointer-events-none' : ''
                                }`}
                                key={index}
                            >
                                {isPendingSummary && (
                                    <div className="absolute inset-0 z-20 flex items-center justify-center rounded-lg bg-black/40">
                                        <div className="flex items-center gap-2 px-3 py-2 rounded-md bg-[#23262D]">
                                            <span className="inline-block w-5 h-5 border-2 rounded-full border-UIprimary border-t-transparent animate-spin"></span>
                                            <span className="text-sm font-medium text-white">
                                                Generating meeting summary...
                                            </span>
                                        </div>
                                    </div>
                                )}
                                <div className="justify-between sm:flex gap-x-6">
                                    <div className="mb-5 sm:flex gap-x-4 lg:items-center sm:mb-0">
                                        <div>
                                            <div className="flex-auto min-w-0 mb-3 xl:w-48">
                                                <p className="mb-1 text-sm leading-5 text-white truncate">
                                                    {this.props.t(
                                                        `${AppConfig.labels.channelName}`
                                                    )}
                                                </p>
                                                <p className="mb-0 text-base font-normal leading-6 text-UIsecondary">
                                                    {session.subject
                                                        ? session.subject
                                                        : RESPONSE_CONSTANT.HYPHEN}
                                                </p>
                                            </div>
                                            <div className="flex-auto min-w-0 mb-3 xl:w-48 sm:mb-0">
                                                <p className="mb-1 text-sm leading-5 text-white truncate">
                                                    {this.props.t('element')}
                                                </p>
                                                <p className="mb-0 text-base font-normal leading-6 text-UIsecondary">
                                                    {session.subCategory
                                                        ? session.subCategory
                                                        : RESPONSE_CONSTANT.HYPHEN}
                                                </p>
                                            </div>
                                        </div>
                                        <span
                                            className="hidden w-px h-24 xxl:ml-8 xxl:mr-8 lg:ml-4 lg:mr-4 line-bg sm:block"
                                            aria-hidden="true"
                                        ></span>
                                        <div>
                                            {session.sessionType === Scheduled ||
                                            session.sessionType === OnDemand ||
                                            session.sessionType === InPerson ||
                                            !session.sessionType === BroadCastSession ? (
                                                <div className="flex-auto min-w-0 mb-3 xl:w-48">
                                                    <p className="mb-1 text-sm leading-5 text-white truncate">
                                                        {this.props.t('teamMemberName')}
                                                    </p>
                                                    <p
                                                        className="mb-0 text-base font-normal leading-6 truncate text-UIsecondary"
                                                        title={session.studentName?.trim() || '-'}
                                                    >
                                                        {session.studentName?.trim() || '-'}
                                                    </p>
                                                </div>
                                            ) : (
                                                <div className="flex-auto min-w-0 mb-3 xl:w-48">
                                                    <p className="mb-1 text-sm leading-5 text-white truncate">
                                                        {this.props.t('numberOfTeamMembers')}
                                                    </p>
                                                    <p className="mb-0 text-base font-normal leading-6 text-UIsecondary">
                                                        {session.studentCount}
                                                    </p>
                                                </div>
                                            )}
                                            <div className="flex-auto min-w-0 mb-3 xl:w-48 sm:mb-0">
                                                <p className="mb-1 text-sm leading-5 text-white truncate">
                                                    {this.props.t('dateAndTime')}
                                                </p>
                                                <p className="mb-0 text-base font-normal leading-6 text-UIsecondary">
                                                    {moment(session.sessionStartDate)
                                                        .locale(
                                                            this.props.language ||
                                                                AppConfig.appLanguage ||
                                                                'en'
                                                        )
                                                        .format('MMM DD, YYYY hh:mm A')}
                                                </p>
                                            </div>
                                        </div>
                                        <span
                                            className="hidden w-px h-24 xxl:ml-8 xxl:mr-8 lg:ml-4 lg:mr-4 line-bg sm:block"
                                            aria-hidden="true"
                                        ></span>
                                        <div>
                                            <div className="flex-auto min-w-0 mb-3 xl:w-48">
                                                <p className="mb-1 text-sm leading-5 text-white truncate">
                                                    {this.props.t('sessionType')}
                                                </p>
                                                <SessionType sessionType={session.sessionType} />
                                            </div>
                                            <div className="flex-auto min-w-0 mb-0 xl:w-48">
                                                <p className="mb-1 text-sm leading-5 text-white truncate">
                                                    {this.props.t('createdBy')}
                                                </p>
                                                <p
                                                    className="mb-0 text-base font-normal leading-6 truncate text-UIsecondary"
                                                    title={session.createdBy}
                                                >
                                                    {session.createdBy}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex flex-col items-center justify-center">
                                        <div className="relative flex flex-col justify-center gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-end">
                                            {session.isRaisedRequest &&
                                            !session.isAllowedToCancel ? (
                                                <span
                                                    className="mdl-list__item-secondary-content "
                                                    style={{ color: 'white', fontWeight: 'bold' }}
                                                >
                                                    {this.props.t(
                                                        'sessionIsRequestedForCancelOrReschedule'
                                                    )}
                                                </span>
                                            ) : (
                                                <>
                                                    {this.canShowEditButton(session) &&
                                                    !!session.sessionId &&
                                                    !!this.props.match?.params?.userId ? (
                                                        <button
                                                            type="button"
                                                            className="inline-flex items-center justify-center w-8 h-8 border rounded-lg text-emerald border-emerald"
                                                            onClick={(event) => {
                                                                event.preventDefault();
                                                                event.stopPropagation();
                                                                this.navigateToSessionEdit(
                                                                    session.sessionId
                                                                );
                                                            }}
                                                            title={this.props.t('edit')}
                                                        >
                                                            <i className="fas fa-pen"></i>
                                                        </button>
                                                    ) : null}

                                                    {/* {session.sessionStatus === "Completed" && (
                            <div className="flex">
                              <iconify-icon
                                className="p-4"
                                style={{
                                  cursor: !session.isFlagged ? "pointer" : "",
                                  color: session.isFlagged ? "#28235c" : "",
                                  borderRadius: "50%",
                                  padding: "6px",
                                  right: 0,
                                }}
                                icon={
                                  session.isFlagged
                                    ? "ph:flag-fill"
                                    : "ph:flag-thin"
                                }
                                width="24"
                                height="24"
                                onClick={() => {
                                  if (!session.isFlagged) {
                                    this.openFlagModal(session.sessionId);
                                  }
                                }}
                              ></iconify-icon>
                            </div>
                          )} */}
                                                    <SessionStatusButton
                                                        status={session.sessionStatus}
                                                        visitId={session.sessionId}
                                                        sessionType={session.sessionType}
                                                        isStudentSessionList={false}
                                                        navigateToDetailScreen={(type, visitId) =>
                                                            this.navigateToDetailScreen(
                                                                type,
                                                                visitId
                                                            )
                                                        }
                                                        joinText={this.props.t('join')}
                                                    />
                                                </>
                                            )}
                                            {(session.createdByWhom === 'Educator' ||
                                                session.createdByWhom === 'Student') &&
                                            session.sessionStatus === 'Booked' &&
                                            session.isAllowedToCancel ? (
                                                <button
                                                    type="button"
                                                    className="inline-flex justify-center text-white bg-black rounded-lg font-medium lg:px-3 px-2 sm:py-1.5 lg:py-3 w-40 text-nowrap"
                                                    onClick={() =>
                                                        this.openCancelModal(session.sessionId)
                                                    }
                                                >
                                                    {this.props.t('cancelSession')}
                                                </button>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                        <div>
                                            {/* {!session.isReferred && session.isAllowedToReferral && (
                        <button
                          type="button"
                          className="w-full inline-flex justify-center text-base rounded-lg font-medium lg:px-3 my-3 px-2 py-1.5 text-white bg-emerald sm:w-full"
                          onClick={() => {
                            this.openSesssionReferralModal(session.sessionId);
                            this.getEducatorForReferral(
                              session.sessionStartDate,
                              session.sessionEndDate,
                              session.sessionId
                            );
                          }}
                        >
                          Create Referral
                        </button>
                      )} */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                        })}
                    </>
                )}
            </>
        );
    }

    /**
     * Handle toggle modal
     * @param {String} pictureUrl
     */
    render() {
        let pageDisplayCount = this.state.totalPages;
        const { userType } = store.get('userSession') ? store.get('userSession') : '';
        return (
            <div className="fixed top-0 left-0 flex w-full h-full">
                <div
                    className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${
                        this.state.mobileNav ? 'block' : 'hidden'
                    }`}
                ></div>
                <NavigationBar
                    nav={true}
                    {...this.props}
                    active={PATH.IM_PHYSICIAN.APPOINTMENT}
                    mobileNav={this.state.mobileNav}
                    onClickMobileNav={this.onClickMobileNav}
                />
                <main className="flex flex-col flex-grow overflow-auto">
                    <Headers
                        {...this.props}
                        title={this.props.t('sessions')}
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <div className="flex flex-col w-full h-full py-8 overflow-auto bg-UIBackground">
                        <div className="items-center justify-between px-4 sm:flex sm:px-8">
                            <h6 className="m-0 text-4xl font-medium text-white">
                                {this.props.t('sessions')}
                            </h6>

                            <div
                                className={`sm:flex gap-4 sm:mt-0 mt-4 ${
                                    this.state.customSelect ? 'lg:w-2/8' : 'lg:w-2/6'
                                }`}
                            >
                                <div className="relative w-full">
                                    <select
                                        id="countries"
                                        className="w-full bg-[#23262D] text-white font-normal rounded block py-1.5 px-2 pr-10 
               appearance-none text-UIprimary cursor-pointer"
                                        onChange={this.handleChangeFilterSortBy}
                                    >
                                        <option value="all" className="text-white">
                                            {this.props.t('allSessions')}
                                        </option>
                                        <option value="today" className="text-white">
                                            {this.props.t('todaySession')}
                                        </option>
                                        <option value="previous" className="text-white">
                                            {this.props.t('previousSession')}
                                        </option>
                                        <option value="future" className="text-white">
                                            {this.props.t('upcomingSessions')}
                                        </option>
                                        <option value="custom" className="text-white">
                                            {this.props.t('customDate')}
                                        </option>
                                        {/* <option value="flagged_session" className="text-white">Flagged</option> */}
                                    </select>
                                    <div className="absolute inset-y-0 flex items-center pointer-events-none right-3">
                                        <svg
                                            className="w-4 h-4 text-UIprimary"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                {this.state.customSelect ? (
                                    <div className="relative flex-wrap items-stretch w-full mb-0 sm:flex">
                                        <div className="flex w-full mt-2 mb-0 bg-[#23262D] rounded border-black-10 sm:mt-0">
                                            <div className="grow">
                                                <DatePicker
                                                    name="date"
                                                    className="w-full px-2 text-base leading-normal text-white placeholder:text-secondary example-custom-input"
                                                    placeholderText={this.props.t('selectAnyDate')}
                                                    selected={
                                                        (this.state.date &&
                                                            new Date(this.state.date)) ||
                                                        null
                                                    }
                                                    value={this.state.date}
                                                    onChange={(event) => {
                                                        this.handleChangeFilterCustomDate(event);
                                                        this.setState({
                                                            date: event,
                                                        });
                                                    }}
                                                    dropdownMode="select"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    yearDropdownItemNumber={80}
                                                    scrollableYearDropdown
                                                    autoComplete="off"
                                                    locale={
                                                        this.props.language === 'es' ? 'es' : 'en'
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    ''
                                )}
                                <button
                                    className="bg-UIprimary p-3 py-1.5 rounded-lg text-white font-medium whitespace-nowrap text-base sm:mt-0 mt-4"
                                    onClick={() =>
                                        this.props.history.push(
                                            `${PATH.IM_PHYSICIAN.APPOINTMENT}/${this.props.match.params.userId}/create`
                                        )
                                    }
                                >
                                    {this.props.t('createSession')}
                                </button>
                            </div>
                        </div>
                        {userType === userTypePhysician ? (
                            <>
                                {this.state.isLoading ? (
                                    <Loader />
                                ) : (
                                    <div className="flex flex-col gap-4 px-4 pt-6 sm:px-8">
                                        {this.renderSessionList()}
                                        <div className="flex items-center justify-end gap-2 mt-4 -space-x-px">
                                            {pageDisplayCount > 1 && (
                                                <Pagination
                                                    currentPage={this.state.currentPage}
                                                    pageDisplayCount={pageDisplayCount}
                                                    onPageChange={this.handlePageChange}
                                                />
                                            )}
                                        </div>
                                        <SessionCancellation
                                            openModal={this.state.cancelAppoimentIsOpen}
                                            closeModal={() => {
                                                this.setState({ cancelAppoimentIsOpen: false });
                                            }}
                                            onChange={(event) => {
                                                this.setState({
                                                    cancelationReason: event.target.value,
                                                });
                                            }}
                                            submitCancelation={() => {
                                                this.submitCancelation();
                                            }}
                                            btnLoading={this.state.btnLoading}
                                        />
                                        <SessionReferral
                                            openModal={this.state.sessionReferralModal}
                                            closeModal={() => {
                                                this.setState({ sessionReferralModal: false });
                                            }}
                                            onChange={(event) => {
                                                this.setState({
                                                    referralNotes: event.target.value,
                                                });
                                            }}
                                            submitCancelation={this.submitReferral}
                                            isEducatorLoading={this.state.isEducatorLoading}
                                            btnLoading={this.state.btnLoading}
                                            educatorList={this.state.educatorList}
                                        />
                                    </div>
                                )}
                            </>
                        ) : (
                            ''
                        )}
                        {!this.state.isFlagSession && (
                            <FlaggingCategorySession
                                {...this.state}
                                openModal={this.state.isFlagModalOpen}
                                closeModal={() => this.setState({ isFlagModalOpen: false })}
                                submitFlagSession={() => {
                                    this.flagSubmitBtn();
                                }}
                                onChange={(event, name) => {
                                    this.onChangeFlagSession(event, name);
                                }}
                            />
                        )}
                    </div>
                </main>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
        getTutorSessionList: (type, strDate, pageNumber, itemsPerPage, callBack) => {
            dispatch(getTutorSessionList(type, strDate, pageNumber, itemsPerPage, callBack));
        },
        sessionAppointmentCancel: (values, callback) => {
            dispatch(sessionAppointmentCancel(values, callback));
        },
        getNumberOfStudentsList: (id, callBack) => {
            dispatch(getNumberOfStudentsList(id, callBack));
        },
        submitFlagSession: (values, callback) => {
            dispatch(submitFlagSession(values, callback));
        },
        flagSessionCategory: (callback) => {
            dispatch(flagSessionCategory(callback));
        },
        getEducatorForReferral: (sessionStartTime, sessionEndTime, visitId, values, callback) => {
            dispatch(
                getEducatorForReferral(sessionStartTime, sessionEndTime, visitId, values, callback)
            );
        },
        submitReferralNotes: (values, callback) => {
            dispatch(submitReferralNotes(values, callback));
        },
        getAllSessions: (type, strDate, pageNumber, itemsPerPage, callBack) => {
            dispatch(getAllSessions(type, strDate, pageNumber, itemsPerPage, callBack));
        },
        getCallStatus: (id, callback) => {
            dispatch(getCallStatus(id, callback));
        },
        getVisitInformation: (visitId, callBack) => {
            dispatch(getVisitInformation(visitId, callBack));
        },
    };
};

const ConnectedSessionList = withLanguage(connect(null, mapDispatchToProps)(SessionList));

export default (props) => (
    <LanguageProvider>
        <ConnectedSessionList {...props} />
    </LanguageProvider>
);
